import { Grid, Typography } from '@mui/material'
import HistoryDetails from '../form/HistoryDetails'

export default function HistoryLabel(props) {
  return <Grid sx={{ display: 'flex', alignItems: 'center' }} item xs={12} sm={12}>
    <Typography fontWeight={'bold'}>{props.label}&nbsp;&nbsp;&nbsp;</Typography><HistoryDetails id={props.id} changes={props.changes} />
  </Grid>
}